module.exports = __webpack_public_path__ + "media/18.70cc3b87.mp3";